import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    buttons: {
        textAlign: 'right'
    }
});

const ControlMachineForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="LicenseVaultID"
                                type="number"
                                value={values.LicenseVaultID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LicenseVaultID && touched.LicenseVaultID)}
                                placeholder={translations["name"] || "License Vault ID"}
                                label={translations["name"] || "License Vault ID"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="NumberOfLicenses"
                                type="number"
                                value={values.NumberOfLicenses}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.NumberOfLicenses && touched.NumberOfLicenses)}
                                placeholder={translations["number_of_licenses"] || "Number of Licenses"}
                                label={translations["number_of_licenses"] || "Number of Licenses"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Unit"
                                value={values.Unit}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Unit && touched.Unit)}
                                placeholder={translations["unit"] || "Unit"}
                                label={translations["unit"] || "Unit"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={!(isValid && dirty)}
                                    >
                                        {formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(ControlMachineForm);
